module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lynx/lyn_names-564c3523abd4751ceed5dfac6e7e4673.gif";